import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class CoachingCoacheeCohortGoalsController extends Controller {
  queryParams = ['add'];

  @tracked add: string | null = null;
}
